import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from "../carrier/response-container";
import { QCSampleRequest } from "./qc-sample-request";
import { timeout, tap } from 'rxjs/operators';

@Injectable()
export class QcSampleService {
    defaultTimeout = 600000;
    constructor(private http: HttpClient) {

    }

    getQcSampleBuildInfo(): Observable<BBResponseContainer> {
        return this.http.get<BBResponseContainer>(environment.BB_QC_SAMPLE_SERVICE_URL + 'qcSampleTypes')
    }

    /*
    get Qc primers when both the parameters active and  qcPrimer are true.
    */
    getQcPrimers(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/primer/standard/qcprimer';
        let requestParam = new HttpParams().set('active', 'true')
            .set('qcPrimer', 'true');
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    registerQcSamples(qcSampleRequest: QCSampleRequest): Observable<BBResponseContainer> {
        return this.http.post<BBResponseContainer>(environment.BB_QC_SAMPLE_SERVICE_URL + 'qcSamples', qcSampleRequest).pipe(timeout(this.defaultTimeout));
    }


}
